module.exports = __webpack_public_path__ + "static/hal-gatewood-613602-unsplash-52feef423f969c9355301ad0f2269661.jpg";